import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Stock } from './stock';
import { StockService } from './stock.service';
import { Bin } from '../location/bin';
import { BinService } from '../location/bin.service';

import { Message, ConfirmationService, SelectItem } from 'primeng/primeng';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css'],
  providers: [ConfirmationService]
})
export class StockComponent implements OnInit {

  stockList: Stock[];
  msgs: Message[];
  selectedStock: Stock;
  selectedStockBin: Bin;
  areaId: number;
  stockTypeList: SelectItem[];

  dataChartKPI: any;

  constructor(private stockService: StockService, private router: Router,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute, private binService: BinService) {
    this.stockList = [];
    this.msgs = [];
    this.selectedStock = new Stock();
    this.selectedStockBin = new Bin();

    this.dataChartKPI = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Availability',
          data: [65, 59, 80, 81, 56, 55, 40],
          fill: false,
          borderColor: '#4bc0c0'
        }
      ]
    }

  }

  ngOnInit() {
    this.loadStocks();
  }

  private loadStocks() {
    console.log('load stocks triggerd');
    this.stockService.list().subscribe(
      (stockArray: Stock[]) => {
        console.log('stocks received: ' + JSON.stringify(stockArray));
        this.stockList = [];
        for (var stock of stockArray) {
          this.stockList = [...this.stockList, stock];
        }
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of stocks.' });
      }
    );
  }

/**
 * Is triggered when a new row is selected. It calls bin api to receive bin data so that bin barcode will be displayed.
 * @param event 
 */
  public onStockSelected(event: any) {
    console.log('Receive bin for selected stock.');
    if (this.selectedStock != null) {
      console.log('Call bin api.');
      this.binService.qryBin(this.selectedStock.binid).subscribe(
        (bin: Bin) => {
          console.log('Received bin:' + bin.id);
          if (bin != null) {
            this.selectedStockBin = bin;
          }
        }
      );
    }
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    if (this.selectedStock == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Keine Bestand ausgewaehlt.' });
      return;
    }

    this.router.navigate(['/stock', this.selectedStock.id])
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedStock == null) {
      this.msgs.push({ severity: 'info', summary: 'Kein Bestand ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Möchten Sie den Bestand wirlich löschen?',
      accept: () => {
        this.stockService.delete(this.selectedStock.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Bestand wurde gelöscht.' });
              this.loadStocks();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Bestand konnte nicht gelöscht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Bestand konnte nicht gelöscht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  /**
   * Saves or updates edited stock entity to server.
   */
  public onSave() {
    if (this.selectedStock == null || this.selectedStock.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an stock first.' });

    if (this.selectedStock.id == -1) {
      this.stockService.save(this.selectedStock).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Bestand wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadStocks();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Bestand konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save stock, error msg: ' + err);
        }
      );
    }
    else {
      this.stockService.update(this.selectedStock).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Bestand wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadStocks();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Bestand konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save stock, error msg: ' + err);
        }
      );
    }
  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/stock/stock.component.ts